import { useState, useEffect, type FC } from "react";
import { MessagesSquare, CalendarDays } from "lucide-react";

import { CalendlyModal } from "@/shared/components/overlay/CalendlyModal";
import { CALENDLY_URLS } from "@/shared/constants/calendlyUrls";

export const HelpSection: FC = () => {
  const [calendlyOpen, setCalendlyOpen] = useState(false);

  useEffect(() => {
    if (!calendlyOpen) return;
    document.body.style.overflow = "";
    return () => {
      document.body.style.overflow = "hidden";
    };
  }, [calendlyOpen]);

  return (
    <div className="rounded-lg border border-primary bg-white overflow-hidden">
      <div className="p-6">
        <h4>Help</h4>
      </div>

      <div className="border-t border-primary" />

      <div className="p-6 flex flex-col gap-6">
        <button
          className="flex items-center gap-3 rounded-sm w-full text-left hover:opacity-80 transition-opacity"
          onClick={() => {
            if (typeof window !== "undefined" && "Intercom" in window) {
              (window as unknown as { Intercom: (cmd: string) => void }).Intercom("show");
            }
          }}
        >
          <div className="h-8 w-8 rounded-sm bg-blue-100 flex items-center justify-center shrink-0">
            <MessagesSquare className="h-4 w-4 text-blue-600" />
          </div>
          <p className="text-sm font-medium">Chat with the Elayne team</p>
        </button>

        <button
          className="flex items-center gap-3 rounded-sm w-full text-left hover:opacity-80 transition-opacity"
          onClick={() => setCalendlyOpen(true)}
        >
          <div className="h-8 w-8 rounded-sm bg-blue-100 flex items-center justify-center shrink-0">
            <CalendarDays className="h-4 w-4 text-blue-600" />
          </div>
          <p className="text-sm font-medium">Schedule a call</p>
        </button>

        <p className="text-sm text-secondary">
          Questions? Email{" "}
          <a
            href="mailto:support@elayne.com"
            className="underline underline-offset-2 hover:opacity-80 transition-opacity"
          >
            support@elayne.com
          </a>{" "}
          or call (201) 305-0072.
        </p>
      </div>

      {calendlyOpen && (
        <CalendlyModal
          isOpen={calendlyOpen}
          onClose={() => setCalendlyOpen(false)}
          url={CALENDLY_URLS.ATTORNEY_SUPPORT}
        />
      )}
    </div>
  );
};
